import { ArtData } from "./art";
import { SITE_DATA_PARTITIONS } from "./siteTable";
import { FromConstObject } from ".";

export type ShipmentKey = {
  PK: typeof SITE_DATA_PARTITIONS.SHIPMENT;
  SK: string;
};

export type ShipmentKeyComponents = {
  type: typeof SITE_DATA_PARTITIONS.SHIPMENT;
  slug: string;
};
export type ShipmentGSI1KeyComponents = {
  type: typeof SITE_DATA_PARTITIONS.SHIPMENT;
  slug: string;
  orderSlug: string;
};
export const SHIPPING_PROVIDERS = {
  USPS: "usps",
  FEDEX: "fedex",
  UPS: "ups",
  OTHER: "other",
  NONE: "",
} as const;
export type ShippingProviderType = FromConstObject<typeof SHIPPING_PROVIDERS>;


export type ShipmentData = ShipmentKeyComponents &
  ShipmentGSI1KeyComponents & {
    orderSlug: string;
    createdAt?: string;
    updatedAt?: string;
    items: ArtData[];
    isShipped: boolean;
    shippingProvider: {
      type: ShippingProviderType;
    } & (
      | {
          type: typeof SHIPPING_PROVIDERS.NONE;
        }
      | {
          type: typeof SHIPPING_PROVIDERS.OTHER;
          name?: string;
          contactInfo?: string;
        }
      | {
          type: Exclude<
            ShippingProviderType,
            typeof SHIPPING_PROVIDERS.OTHER | typeof SHIPPING_PROVIDERS.NONE
          >;
          trackingNumber?: string;
        }
    );
  };

export type ShipmentDBData = ShipmentKey & ShipmentData;
